import React from "react";
import { useNavigate } from "react-router-dom";
import { PATHS } from "../../../routes/paths";
import graphic from "../../../assets/_home/hero_image.svg";
import styles from "./Hero.module.scss";

const Hero = () => {
  const navigate = useNavigate();

  return (
    <section className={styles.container}>
      <div className={styles.subContainer}>
        <div className={styles.leftContainer}>
          <h1>
            The marketplace <br /> built on <span>solana</span> <br />{" "}
            <span>blockchain</span>.
          </h1>
          <p>
            The first Solana marketplace that allows people to upload and
            transfer ownership of documents.
          </p>
          <div className={styles.btnContainer}>
            <button onClick={() => navigate("/explore-collection")}>Explore NFTs</button>
            <button onClick={() => navigate(PATHS.createCollection)}>
              Create
            </button>
          </div>
        </div>

        <div className={styles.rightContainer}>
          <img src={graphic} alt="hero-pic" />
        </div>
      </div>
    </section>
  );
};

export default Hero;
